<template>
  <div class="subscribe">
    <div class="dark-theme maxWidth">
      <el-form :inline="true" ref="formRef" :model="search_form" class="ant-advanced-search-form" size="small">
        <el-form-item label="预约人" class="search_item" prop="userName">
          <el-input v-model="search_form.userName" placeholder="请输入预约人" @change="$forceUpdate()"></el-input>
        </el-form-item>
        <el-form-item label="预约时间" prop="time">
          <el-date-picker v-model="search_form.time" @change="$forceUpdate()" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="search_form.status" placeholder="请选择预约状态" @change="$forceUpdate()">
            <el-option v-for="(item, index) in types" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="" class="mr-10" icon="el-icon-refresh" @click="operation('reset')">重置</el-button>
          <el-button type="primary" icon="el-icon-search" @click="operation('search')">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" :data="tableList" row-key="id" class="mt20" >
        <el-table-column label="序号" align="center" type="index" width="80" />
        <el-table-column label="预约类型" align="center" prop="createTime">
          <template slot-scope="scope">
            {{ scope.row.type == 1 ? '场馆预约' : '科技预约' }}
          </template>
        </el-table-column>
        <el-table-column label="预约内容" align="center" prop="startTime" min-width="240">
          <template slot-scope="scope">
            <div class="serveCont">
              <div v-if="scope.row.type == 1">场馆名称：{{ scope.row.venueName || '-'}}</div>
              <div v-else>科技服务：{{ scope.row.scienceServiceName }}/{{ scope.row.venueName }}</div>
              <div>预约时间：{{ moment(scope.row.startTime).format("yyyy-MM-DD HH:mm") }} - {{ moment(scope.row.endTime).format("HH:mm") }}</div>
              <div v-if="scope.row.type == 1">场馆地址：{{ scope.row.province&&scope.row.city&&scope.row.area ? `${scope.row.province}/${scope.row.city}/${scope.row.area} ${scope.row.venueAddress}` : '-' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="预约人" align="center"></el-table-column>
        <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
        <el-table-column label="所属队伍" align="center" prop="team"></el-table-column>
        <el-table-column label="状态" align="center" prop="createTime">
          <template slot-scope="scope">
            <span 
              :class="{'pending': scope.row.status == 1,'ok': scope.row.status == 2,'refuse': scope.row.status == 3,'cancel': scope.row.status == 4,}">
              {{ typeObj[scope.row.status] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" align="center" prop="createTime" width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime && moment(scope.row.createTime).format("yyyy-MM-DD HH:mm") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" min-width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="handleOK(scope.row)" v-if="scope.row.status == 1">通过</el-button>
            <el-button size="mini" type="danger" plain @click="handleRefuse(scope.row)" v-if="scope.row.status == 1">拒绝</el-button>
            <el-button size="mini" type="primary" plain @click="handleDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="search_form.pageNum" :limit.sync="search_form.pageSize" @pagination="_getList" />
    </div>


    <!-- 添加/编辑场馆 -->
    <a-modal title="审核不通过" width="600px" :visible.sync="showDialog">
      <el-form :model="orderForm" :rules="rules"  ref="orderRef" label-width="80px" class="px20">
        <el-form-item label="拒绝原因" name="statusRemark" prop="statusRemark">
          <a-textarea
            v-model="orderForm.statusRemark"
            placeholder="输入拒绝原因"
            show-count
            :rows="4"
            :maxlength="200"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </a-modal>


    <el-dialog title="预约详情" width="670px" :visible.sync="detailDialog">
      <div class="orderDtl">
        <div class="statTag">
          <img src="@/assets/venue/status_pending.png" alt="" v-if="orderForm.status == 1">
          <img src="@/assets/venue/status_ok.png" alt="" v-if="orderForm.status == 2">
          <img src="@/assets/venue/status_refuse.png" alt="" v-if="orderForm.status == 3">
          <img src="@/assets/venue/status_cancel.png" alt="" v-if="orderForm.status == 4">
        </div>
        <div v-if="orderForm.type == 1">
          <div class="size18 mb20 flex-s-c">
            <div class="label" style="width: auto;">预约类型：</div>
            <div class="blank">
              <img src="@/assets/venue/venue_icon.png" alt="" class="venue_icon">
              场馆预约
            </div>
          </div>
          <div class="flex mb10">
            <div class="label">场馆名称</div>
            <div class="sym">：</div>
            <div class="value">{{orderForm.venueName}}</div>
          </div>
          <div class="flex mb10">
            <div class="label">预约时间</div>
            <div class="sym">：</div>
            <div class="value"> {{moment(orderForm.startTime).format("yyyy-MM-DD HH:mm")}} - {{moment(orderForm.endTime).format("HH:mm")}}</div>
          </div>
          <div class="flex mb10">
            <div class="label">预约人数</div>
            <div class="sym">：</div>
            <div class="value"> 男{{orderForm.boyNum || 0}}人，女{{orderForm.grilNum || 0}}人</div>
          </div>
          <div class="flex">
            <div class="label">场馆地址</div>
            <div class="sym">：</div>
            <div class="value">{{ orderForm.province&&orderForm.city&&orderForm.area ? `${orderForm.province}/${orderForm.city}/${orderForm.area} ${orderForm.venueAddress}` : '-' }}</div>
          </div>
        </div>
        <div  v-if="orderForm.type == 2">
          <div class="size18 mb20 flex-s-c">
            <div class="label" style="width: auto;">预约类型：</div>
            <div class="blank">
              <img src="@/assets/venue/serve_icon.png" alt="" class="serve_icon">
              科技预约
            </div>
          </div>
          <div class="flex mb10">
            <div class="label">科技服务</div>
            <div class="sym">：</div>
            <div class="value">{{orderForm.scienceServiceName}}/{{ orderForm.venueName }}</div>
          </div>
          <div class="flex mb10">
            <div class="label">预约时间</div>
            <div class="sym">：</div>
            <div class="value"> {{moment(orderForm.startTime).format("yyyy-MM-DD HH:mm")}} - {{moment(orderForm.endTime).format("HH:mm")}}</div>
          </div>
          <div class="flex">
            <div class="label">预约人数</div>
            <div class="sym">：</div>
            <div class="value"> 男{{orderForm.boyNum || 0}}人，女{{orderForm.grilNum || 0}}人</div>
          </div>
        </div>
        
        <el-divider class="mb20 mt20"></el-divider>
        <el-row class="mb10">
          <el-col :span="12" class="flex">
            <div class="label">预约人</div>
            <div class="sym">：</div>
            <div class="value">{{orderForm.userName}}</div>
          </el-col>
          <el-col :span="12" class="flex">
            <div class="label">联系电话</div>
            <div class="sym">：</div>
            <div class="value">{{orderForm.phone}}</div>
          </el-col>
        </el-row>
        <el-row class="mb10">
          <el-col :span="12" class="flex">
            <div class="label">提交时间</div>
            <div class="sym">：</div>
            <div class="value">{{moment(orderForm.createTime).format("yyyy-MM-DD HH:mm")}}</div>
          </el-col>
          <el-col :span="12" class="flex">
            <div class="label">预约队伍</div>
            <div class="sym">：</div>
            <div class="value">{{orderForm.team}}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" class="flex">
            <div class="label">备注</div>
            <div class="sym">：</div>
            <div class="value">{{orderForm.remark || '-'}}</div>
          </el-col>
        </el-row>
        <el-divider class="mb20 mt20"></el-divider>
        <div v-if="orderForm.status == 2 || orderForm.status == 3">
          <el-row class="mb10">
            <el-col :span="24" class="flex">
              <div class="label">审批人</div>
              <div class="sym">：</div>
              <div class="value">{{orderForm.statusName || '-'}}</div>
            </el-col>
          </el-row>
          <el-row class="mb10">
            <el-col :span="24" class="flex">
              <div class="label">审批时间</div>
              <div class="sym">：</div>
              <div class="value">{{moment(orderForm.statusTime).format("yyyy-MM-DD HH:mm")}}</div>
            </el-col>
          </el-row>
          <el-row class="mb10" v-if="orderForm.status == 3">
            <el-col :span="24" class="flex">
              <div class="label">审批意见</div>
              <div class="sym">：</div>
              <div class="value">{{orderForm.statusRemark}}</div>
            </el-col>
          </el-row>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { Modal } from "ant-design-vue";
export default {
  data(){
    return {
      search_form: {
        pageNum: 1,
        pageSize: 10,
        status: '',
        userName: '',
        startTime: "",
        endTime: "",
        time: [],
      },
      loading: false,
      tableList: [],
      total: 0,

      showDialog: false,
      orderForm: {
        statusRemark: '',
      },
      rules: {
				statusRemark: [{ required: true, message: "请输入拒绝原因", trigger: "blur", }],
      },
      typeObj: {
        '1': '待审核',
        '2': '审核通过',
        '3': '审核拒绝',
        '4': '已取消',
      },
      types: [
        { name: '全部', value: '' },
        { name: '待审核', value: 1 },
        { name: '审核通过', value: 2 },
        { name: '审核拒绝', value: 3 },
        { name: '已取消', value: 4 },
      ],
      detailDialog: false,
      userRole: null
    }
  },
  computed: {
    changeTime(){
      return function(time, type){
        type = type ? type : 'YYYY-MM-DD hh:mm:ss'
        return moment(time).format(type)
      }
    },
    moment: () => moment,

  },
  methods: {
    moment,
    _getList() {
      let params = {
        ...this.search_form,
        startTime: this.search_form.time.length && moment(this.search_form.time[0]).valueOf() || '',
        endTime: this.search_form.time.length && moment(this.search_form.time[1]).valueOf() || ''
      }
      delete params.time
      this.$axios.get('/api/qhd/VenueOrder/findSysVenueOrderList', params).then(res=>{
        if (res.code == 200) {
          this.tableList = res.data.list
          this.total = res.data.total
        }
      })
    },
    reset(form) {
      for (let key in form) {
        form[key] = null;
      }
    },
    refreshList() {
      // formRef
      this.$refs['formRef'].resetFields();
      // this.search_form.pageNum = 1
      this._getList()
    },

    subAddAddress() {
      this.$refs["venueRef"].validate((valid) => {
        if (valid) {

        } else {
          return false;
        }
      });
    },
    
    operation(type){
      switch(type) {
        case 'search':
          this.search_form.pageNum = 1
          this._getList()
          break;
        case 'reset':
          this.refreshList()
          break;

      }
    },
    handleDetail(e) {
      this.orderForm = JSON.parse(JSON.stringify(e))
      this.detailDialog = true
    },
    _refuse(e) {
      this.$axios.get("/api/qhd/VenueOrder/updateVenueOrderStatus", { ...this.orderForm }).then((res) => {
        if (res.code == 200) {
          this.$message.success("操作成功");
          this.showDialog = false
          this.refreshList()
        }
      });
    },
    handleSubmit() {
      this.$refs["orderRef"].validate((valid) => {
        if (valid) {
          this._refuse()
        } else {
          return false;
        }
      });
    },
    _ok(e) {
      let order = JSON.parse(JSON.stringify(e))
      let params = {
        id: order.id,
        status: '2'
      }
      
      this.$axios.get("/api/qhd/VenueOrder/updateVenueOrderStatus", params).then((res) => {
        if (res.code == 200) {
          this.$message.success("操作成功");
          this.refreshList()
        }
      });
    },
    handleOK(e) {
      this.$confirm(`确定${e.userName}的${e.type == 1 ? '场馆预约' : '科技预约'}审批通过?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this._ok(e)
      }).catch(() => {

      });
    },
    handleRefuse(e) {
      this.orderForm = JSON.parse(JSON.stringify(e))
      this.orderForm.status = '3'
      this.showDialog = true
    }
  },
  created(){
    this._getList()
  }
}
</script>

<style lang="less" scoped>
.subscribe{
  background: var(--bg-color);
  .ok {
    color: #67C23A;
  }
  .refuse {
    color: #F56C6C;
  }
  .pending {
    color: #E6A23C;
  }
  .cancel {
    color: #909399;
  }
  .serveCont {
    width: 240px;
    // max-width: 320px;
    margin: 0 auto;
    text-align: left;
  }
}
.orderDtl {
  position: relative;
  padding-bottom: 30px;
  color: #eee;
  font-size: 14px;
  .statTag {
    position: absolute;
    right: 20px;
    top: 0px;
    width: 127px;
    height: 135px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .blank {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 50px;
    border-radius: 25px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    background-color: #2D3458;
    .venue_icon {
      width: 30px;
      height: 21px;
      margin-right: 8px;
    }
    .serve_icon {
      width: 26px;
      height: 26px;
      margin-right: 8px;
    }
  }
  .time {
    color: #409EFF;
  }
  .label {
    color: #999;
    width: 60px;
    text-align: justify;
    text-align-last:justify;
  }
  .sym {
    color: #999;
  }
}

</style>